module.exports = __webpack_public_path__ + "img/bee-7666216_1280_thumb.2955eb5b.jpg";